<template>
  <div class="visa-type-text" @mouseleave="isHover = false" @mouseenter="isHover = true">
    <template v-if="imgMap[visaType]">
      <img v-show="isHover" class="icon" :src="imgMap[visaType].hover_url" alt="">
      <img v-show="!isHover" class="icon" :src="imgMap[visaType].url" alt="">
    </template>

    <span v-else>{{visaType}}</span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    visaType: String,
  },
  data() {
    return {
      isHover: false,
      imgMap: {
        加急: {
          url: 'https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/visa-type-urgent.png',
          hover_url: 'https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/visa-type-urgent-blue.png',
        },
        VIP办签: {
          url: 'https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/visa-type-vip.png',
          hover_url: 'https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/visa-type-vip-blue.png',
        },
      },
    };
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.visa-type-text{
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .icon{
    height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/country/components/visa-type-text.vue